import React from 'react';

const StepDaysLabel = ({ days }) => <span className="py-1 px-2 rounded-lg bg-secondary text-white">{days}</span>;

export default StepDaysLabel;
